var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAccountBadgePrintAction } from '../../../../../ui/features/badge-management/hooks/useAccountBadgePrintAction';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Button } from '@mui/material';
import React from 'react';
export const PrintBadgeButton = ({ accountBadge, startIcon, variant, size, sx, onRefetch }) => {
    const { t } = useBadgingTranslation();
    const handleAccountBadgePrint = useAccountBadgePrintAction();
    const handlePrintBadge = () => __awaiter(void 0, void 0, void 0, function* () {
        yield handleAccountBadgePrint(accountBadge);
        yield onRefetch();
    });
    return (React.createElement(Button, { startIcon: startIcon, variant: variant, size: size, onClick: (e) => {
            e.stopPropagation();
            handlePrintBadge().catch(handleErrorSnackbar);
        }, sx: Object.assign(Object.assign({}, sx), { whiteSpace: 'nowrap' }) }, t('badges.badgeDetails.accountBadgeTable.actions.print')));
};
